import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon, StarIcon } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { getProduct } from '../../utils/products';
import { formatPrice } from '../../utils/currency';
import { images } from '../../data/images';
import type { Product } from '../../types/product';
import { Reveal } from '../ui/Reveal';
const roles = ['Reinigen', 'Scrubben', 'Behandelen', 'Opfrissen', 'Voeden'];
export function RitualSetFeature() {
  const {
    add
  } = useCart();
  const set = getProduct('hammam-ritueel-set');
  if (!set) return null;
  const variant = set.variants[0];
  const items = (set.includes ?? []).map(slug => getProduct(slug)).filter((p): p is Product => Boolean(p));
  return <section className="bg-berry text-white" data-id="element-121" data-mp="ntuyx17dzawc">
      <div className="grid lg:grid-cols-2" data-id="element-122" data-mp="srmqfu44cv00">
        <div className="relative min-h-[460px] lg:min-h-[820px]" data-id="element-123" data-mp="ssodyy2bn9ym">
          <img src={images.ritual} alt="Het hammam-ritueel: savon beldi, kessa, ghassoul en rozenwater op natte steen" className="absolute inset-0 h-full w-full object-cover" data-id="element-124" data-mp="xqzn16kslgfs" />
          <div className="absolute bottom-5 left-5 flex items-center gap-3 rounded-2xl bg-white p-2 pr-4 text-ink" data-id="element-125" data-mp="2avag8gbj8v9p">
            <img src={set.image} alt="" className="h-14 w-14 rounded-xl object-cover" data-id="element-126" data-mp="26v8b1x6l9jpo" />
            <span className="text-sm" data-id="element-127" data-mp="21vvprgvd8kp7">
              <span className="block font-semibold" data-id="element-128" data-mp="21wyf3kd1if30">5 producten</span>
              <span className="block text-muted" data-id="element-129" data-mp="2ykbfbcyh6u2b">in één doos</span>
            </span>
          </div>
        </div>

        <div className="flex flex-col justify-center px-6 py-16 sm:px-12 lg:px-20 lg:py-24" data-id="element-130" data-mp="2ul2ly97cky7a">
          <Reveal data-id="element-131" data-mp="2prrouzsc7vsk">
            <p className="flex items-center gap-2 text-sm text-white/70" data-id="element-132" data-mp="2pr87plaihbfl">
              <StarIcon className="h-4 w-4 fill-blush text-blush" strokeWidth={0} data-id="element-133" data-mp="2kswtyzh3igs3" />
              {set.rating.toLocaleString('nl-NL')} · {set.reviews} reviews · Bestseller
            </p>
            <h2 className="mt-5 font-display text-4xl uppercase leading-[0.98] tracking-display sm:text-6xl" data-id="element-134" data-mp="3didivn5ibfjk">
              Het hammam&shy;ritueel. <em className="italic text-blush" data-id="element-135" data-mp="a9skk4s9ntw">In één doos.</em>
            </h2>
            <p className="mt-5 max-w-md text-lg text-white/75" data-id="element-136" data-mp="579po5jnng8v">
              Vijf producten in de volgorde waarin je ze gebruikt. Zo weet je precies wat je doet en waarom.
            </p>
          </Reveal>

          <ol className="mt-10 border-t border-white/15" data-id="element-137" data-mp="3rmmdxc2vy11p">
            {items.map((p, i) => <li key={p.slug} className="border-b border-white/15" data-id="element-138" data-mp="3dmtdgp1k46gj" data-mpi={i}>
                <Link to={`/product/${p.slug}`} className="group flex items-center gap-5 py-4" data-id="element-139" data-mp="3inr5dtcdcev8">
                  <span className="w-6 text-sm text-white/45 tabular-nums" data-id="element-140" data-mp="34ohpyvvzlosb">0{i + 1}</span>
                  <span className="flex-1 text-lg font-medium transition-colors duration-150 group-hover:text-blush" data-id="element-141" data-mp="38orue444s752">{p.name}</span>
                  <span className="text-sm text-white/55" data-id="element-142" data-mp="12xo45qveobbv">{roles[i]}</span>
                  <ArrowUpRightIcon className="h-4 w-4 text-white/45 transition-colors duration-150 group-hover:text-blush" data-id="element-143" data-mp="16y822wnsziz2" />
                </Link>
              </li>)}
          </ol>

          <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-6" data-id="element-144" data-mp="2nex9x8cex2so">
            <p className="flex items-baseline gap-3" data-id="element-145" data-mp="315sdc5456rov">
              <span className="text-4xl font-semibold tracking-tight" data-id="element-146" data-mp="317d89vudccn9">{formatPrice(variant.price)}</span>
              {variant.compareAt && <span className="text-white/55 line-through" data-id="element-147" data-mp="2wd8zd71jlujj">{formatPrice(variant.compareAt)}</span>}
            </p>
            <div className="flex flex-wrap gap-3" data-id="element-148" data-mp="364vhzog7mvwb">
              <button onClick={() => add(set.slug, variant.id)} className="inline-flex h-14 items-center whitespace-nowrap bg-white px-8 text-sm font-semibold uppercase tracking-[0.14em] text-berry transition-colors duration-150 hover:bg-blush" data-id="element-149" data-mp="3643pimhwtea9">
                In winkelwagen
              </button>
              <Link to={`/product/${set.slug}`} className="inline-flex h-14 items-center whitespace-nowrap border border-white/40 px-7 text-sm font-semibold uppercase tracking-[0.14em] transition-colors duration-150 hover:border-white" data-id="element-150" data-mp="1krk41c8duev6">
                Bekijk de set
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}